<div class="main">
    <span class="left">{{textFalse}}</span>
    <p-toggleswitch [(ngModel)]="value" (onChange)="switch()"></p-toggleswitch>
    <span class="right">{{textTrue}}</span>
</div>
